import React from 'react';
import ReactDOM from 'react-dom/client';

// Self-hosted fonts — replaces Google Fonts (eliminates render-blocking CSS).
// Subset to cyrillic + latin only (drops greek/greek-ext/vietnamese/
// cyrillic-ext/latin-ext @font-face rules ≈18 KiB unused CSS).
import '@fontsource/inter/cyrillic-400.css';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/cyrillic-500.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/cyrillic-600.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/cyrillic-700.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/instrument-serif/400.css';
import '@fontsource/instrument-serif/400-italic.css';

import App from './App';
import './index.css';
import './lib/i18n';
import { initSentry } from './lib/sentry';

initSentry();

// eslint-disable-next-line import/no-named-as-default-member
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
